import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import './MerchantInfoModal.scss';
import '../../../Model/AppData'
import { WorkingHourType } from '../../../app/User/Handler/WorkingHourHandler';

var portalRoot = null;

class MerchantInfoModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#merchant-info-modal-portal').length == 0) {
            $('body').prepend('<div id="merchant-info-modal-portal"></div>')
        }
        portalRoot = document.getElementById("merchant-info-modal-portal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class MerchantInfoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);
    };
    componentDidUpdate() {
       
    }
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    getButtons = () => {
        if (this.props.buttonLayout == "vertical") {
            return (
                <div className="mt-3">
                    <button id="confirm-modal-btn-yes" onClick={this.props.onYes} className={"btn btn-block mb-2 btn-default"}>{this.props.yesText || lang.close}</button>
                </div>
            )
        }
        else {
            // Default is horizontal layout
            return (
                <div style={{textAlign:"right"}}>
                    <button onClick={this.props.onYes} className="btn btn-primary btn-sm">{this.props.yesText || lang.close}</button>
                </div>
            )
        }
    }
    getMerchant = () => {
        return AppData.data.state.merchant || {}
    }
    phoneNumberCall = () => {
        const {phone_No} = this.getMerchant()
        if (phone_No) {
            let numberToCall = merchant.phone_number.replace(" ", "").replace("-", "")
            let firstDigit = numberToCall.substr(0,1)
            firstDigit = numberToCall.substr(0,1)
            if (firstDigit == "0") {
                numberToCall = "+6" + numberToCall
            }
            else if (firstDigit == "6") {
                numberToCall = "+" + numberToCall
            }
            return numberToCall
        }
    }
    MerchantPhone = () => {
        return <a className="cta full-flex" href={"tel:" + this.phoneNumberCall()}>
            {this.getMerchant().phone_number}
        </a>
    }
    
    
    render() {
        const whMon = this.getWorkingHourForDay('Mon')
        const whTues = this.getWorkingHourForDay('Tue')
        const whWed = this.getWorkingHourForDay('Wed')
        const whThur = this.getWorkingHourForDay('Thu')
        const whFri = this.getWorkingHourForDay('Fri')
        const whSat = this.getWorkingHourForDay('Sat')
        const whSun = this.getWorkingHourForDay('Sun')

        const workingHours = [
            {
                label: lang.monday,
                value: this.getWorkingHourForDay('Mon')
            },
            {
                label: lang.tuesday,
                value: this.getWorkingHourForDay('Tue')
            },
            {
                label: lang.wednesday,
                value: this.getWorkingHourForDay('Wed')
            },
            {
                label: lang.thursday,
                value: this.getWorkingHourForDay('Thu')
            },
            {
                label: lang.friday,
                value: this.getWorkingHourForDay('Fri')
            },
            {
                label: lang.saturday,
                value: this.getWorkingHourForDay('Sat')
            },
            {
                label: lang.sunday,
                value: this.getWorkingHourForDay('Sun')
            },
        ]

        return (
            <MerchantInfoModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="fadeIn">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div style={{textAlign:"center"}}>
                        <div><h4>{this.getMerchant().name}</h4></div>
                        <table border={"0"} width={"300px"} style={{textAlign:"left"}}>
                            <tbody >
                                <tr>
                                    <td colSpan="2">
                                        <div className="mb-2">
                                            <b> {lang.phone}</b>: {this.MerchantPhone()}
                                        </div>
                                        <div className="mb-2">
                                            <b> {lang.addr}</b>: {this.getMerchant().address}
                                        </div>
                                        <div className="mb-2">
                                            <b>{lang.op_hour}</b>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table table-bordered" width={"300px"} style={{textAlign:"left"}} > 
                            <tbody>
                                {
                                    workingHours.map(day => {
                                        return <tr key={day.label}>
                                            <td>{day.label}</td>
                                            <td>
                                                {
                                                    day.value.length == 0 ?
                                                    <div> -- </div> :
                                                    day.value.map((wh, index) => {
                                                        return <div key={index}>{wh}</div>
                                                    })
                                                }
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        </div>
                        <br/>
                        {this.getButtons()}
                    </div>
                </Modal>
            </MerchantInfoModalPortal>
        )
    }
    getWorkingHourForDay(whchar) {
        console.log("getWorkingHourForDay")
        let isUseDeliveryTime = false
        if (this.props.app.isMerchantHasFeature('merchant_info_show_delivery_time')) {
            isUseDeliveryTime = true
        }
        const filterFunc = (wh) => {
            if (wh.day ==  whchar) {
                if (isUseDeliveryTime) {
                    return wh.type == WorkingHourType.DELIVERY
                }
                else {
                    return  wh.type == null || wh.type == WorkingHourType.DINE_IN
                }
            }
            return false
            
        }
        const workingHours = (this.getMerchant() && this.getMerchant().working_hours || [])
            .filter(filterFunc)

        let workingHourStrings = []

        const formatWorkingToString = (wh) => {
            const start = moment(wh.start_time, "HH:mm:ss")
            const end = moment(wh.end_time, "HH:mm:ss")

            let workingHourStr = `${start.format("hh:mma")} - ${end.format("hh:mma")}`
            return workingHourStr
        }

        if (workingHours.length == 1) {
            const wh = workingHours[0]
            // Single working hour, if is 00:00 - 00:01, then business closed
            if (wh.start_time == "00:00:00" && wh.end_time == "00:01:00") {
                // Case A
                return workingHourStrings 
                    // return []
            }
            else {
                // Case B
                const whString = formatWorkingToString(wh)
                workingHourStrings.push(whString)
            }
        }
        else if (workingHours.length > 1){
            // Case C
            workingHours.forEach(wh => {
                const whString = formatWorkingToString(wh)
                workingHourStrings.push(whString)
            })
        }
        return workingHourStrings
    }   
}

MerchantInfoModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default MerchantInfoModal;